module.exports = __webpack_public_path__ + "img/Suv_Back_Side_Left.c69038f9.svg";